import React from "react";
import { DEFAULT_PER_PAGE } from "../helpers/default";

const usePagination = () => {
  const [currentPage, setCurrentPage] = React.useState(1);
  const [currentPerPage, setCurrentPerPage] = React.useState(DEFAULT_PER_PAGE);

  return {
    currentPage,
    setCurrentPage,
    currentPerPage,
    setCurrentPerPage: (val) => {
      setCurrentPage(1);
      setCurrentPerPage(val);
    },
  };
};

export default usePagination;
